import { ResponseError } from '../../errors/responseError';
import { prepareSuggestions } from '../../mappers/prepareSuggestions';
import {
  TGetSuggestionsQueryStringResponse,
  fetchGetSuggestionsQueryString,
} from '../../repositories/text-search/v2/get-suggestions-query-string';
import { IApplicationContext } from '../../types/redux/application';
import { ISuggestion } from '../../types/suggestions';

const DEGRADATION_TELEMETRY_KEY = 'degradation.searchSuggestionsByText';

export async function fetchSuggestionsByText(
  context: IApplicationContext,
  text: string,
  geo?: string,
  tips?: string,
): Promise<ISuggestion[]> {
  const { httpApi, logger, telemetry } = context;

  try {
    const { statusCode, response }: TGetSuggestionsQueryStringResponse = await fetchGetSuggestionsQueryString({
      httpApi,
      parameters: {
        text,
        geo,
        tips,
      },
    });

    if (statusCode !== 200) {
      telemetry.increment(DEGRADATION_TELEMETRY_KEY);

      const responseError = new ResponseError({
        domain: 'services.fetchSuggestionsByText',
        message: response.message || '',
        details: {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          error: response.errors as any,
        },
      });

      logger.warning(responseError);
      throw responseError;
    }

    return prepareSuggestions(response.suggestions);
  } catch (ex) {
    telemetry.increment(DEGRADATION_TELEMETRY_KEY);
    logger.error(ex);

    return [];
  }
}
